// useUnreadNotificationsByBase.js

import { useMemo } from 'react';

/**
 * Groups unread notifications by base key.
 *
 * @param {Array<object>} unreadNotifications - Unread notification rows.
 * @returns {Map<string, number>} Unread count per base key.
 */
export default function useUnreadNotificationsByBase(unreadNotifications = []) {
  return useMemo(() => {
    const counts = new Map();

    if (!Array.isArray(unreadNotifications)) {
      return counts;
    }

    unreadNotifications.forEach((notification) => {
      if (!notification || notification.isRead === true) return;

      const baseKey = String(notification?.baseKey || '').trim();
      if (!baseKey) return;

      counts.set(baseKey, (counts.get(baseKey) || 0) + 1);
    });

    return counts;
  }, [unreadNotifications]);
}
